// extracted by mini-css-extract-plugin
module.exports = {"SectionA3":"SectionA3_SectionA3__TlTia"};